import { Box } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { formatMoney } from 'utils/helpers';
import { Interest, InterestKindEnum } from 'v2-types/order';
import { formatPercent } from 'views/orders/loans/utils';

import { LabelWithValue } from '../components/label-with-value';

export function getInterestTextInfo(interest: Interest, t: TFunction) {
  const { kind } = interest;

  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      style={{ gap: '20px' }}
    >
      {(kind === InterestKindEnum.fixed || kind === InterestKindEnum.only || kind === InterestKindEnum.variable) && (
        <LabelWithValue
          label={t('orders:rateLabelInterest')}
          value={formatPercent(interest.rate)}
        />
      )}

      {kind === InterestKindEnum.adjustable && (
        <>
          <LabelWithValue
            label={t('orders:indexNameLabel')}
            value={interest.index_name}
          />
          <LabelWithValue
            label={t('orders:marginLabel')}
            value={formatPercent(interest.margin)}
          />
        </>
      )}

      {kind === InterestKindEnum.conversion && (
        <>
          <LabelWithValue
            label={t('orders:feeLabel')}
            value={interest.fee ? formatMoney(interest.fee).toString() : ''}
          />
          <LabelWithValue
            label={t('orders:periodStartLabel')}
            value={interest.period_start}
          />
          <LabelWithValue
            label={t('orders:periodEndLabel')}
            value={interest.period_end}
          />
        </>
      )}

      {kind === InterestKindEnum.first && (
        <>
          <LabelWithValue
            label={t('orders:changeDateLabel')}
            value={interest.change_date}
          />
          <LabelWithValue
            label={t('orders:changeMinLabel')}
            value={formatPercent(interest.change_min)}
          />
          <LabelWithValue
            label={t('orders:changeMaxLabel')}
            value={formatPercent(interest.change_max)}
          />
        </>
      )}

      {kind === InterestKindEnum.subsequent && (
        <>
          <LabelWithValue
            label={t('orders:monthsLabel')}
            value={interest.months.toString()}
          />
          <LabelWithValue
            label={t('orders:rateMinLabel')}
            value={formatPercent(interest.rate_min)}
          />
          <LabelWithValue
            label={t('orders:rateMaxLabel')}
            value={formatPercent(interest.rate_max)}
          />
          <LabelWithValue
            label={t('orders:changeMaxLabel')}
            value={formatPercent(interest.change_max)}
          />
        </>
      )}
    </Box>
  );
}
